/*
 * Native localStorage wishlist.
 * - Any element with [data-wishlist-toggle] + data-* (handle/url/title/
 *   image/price/available) saves a product snapshot on click.
 * - A wishlist page renders [data-wishlist-list] from storage and shows
 *   [data-wishlist-empty] when there is nothing saved.
 * No app, no account — saved per browser.
 */
(function () {
  var KEY = 'gold:wishlist';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: list }));
  }
  function has(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }
  function toggle(item) {
    var list = read();
    var idx = list.findIndex(function (i) { return i.handle === item.handle; });
    if (idx > -1) list.splice(idx, 1);
    else list.unshift(item);
    write(list);
    return idx === -1;
  }
  function remove(handle) {
    write(read().filter(function (i) { return i.handle !== handle; }));
  }
  window.GoldWishlist = { read: read, has: has, toggle: toggle, remove: remove };

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function reflectButtons() {
    // Fill the header icon while the wishlist holds something — a quiet
    // signal that replaces a count badge.
    var any = read().length > 0;
    document.querySelectorAll('[data-wishlist-open]').forEach(function (btn) {
      btn.classList.toggle('is-active', any);
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = has(btn.dataset.handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function renderPage() {
    var lists = document.querySelectorAll('[data-wishlist-list]');
    if (!lists.length) return;
    var items = read();
    document.querySelectorAll('[data-wishlist-empty]').forEach(function (e) {
      e.hidden = items.length > 0;
    });
    var html = items.map(function (i) {
      return (
        '<article class="wishlist-card">' +
          '<a class="wishlist-card__media" href="' + esc(i.url) + '">' +
            (i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<div class="wishlist-card__info">' +
            '<a class="wishlist-card__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
            '<div class="wishlist-card__price">' + esc(i.price) + '</div>' +
          '</div>' +
          '<button type="button" class="wishlist-card__remove" data-wishlist-remove="' + esc(i.handle) + '" aria-label="Remove">' +
            '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15"/></svg>' +
          '</button>' +
        '</article>'
      );
    }).join('');
    lists.forEach(function (list) {
      list.hidden = items.length === 0;
      list.innerHTML = html;
    });
  }

  function drawer() { return document.querySelector('[data-wishlist-drawer]'); }
  function openDrawer() {
    var d = drawer();
    if (d && typeof d.showModal === 'function' && !d.open) d.showModal();
  }
  function closeDrawer() {
    var d = drawer();
    if (d && d.open) d.close();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-wishlist-close]')) { closeDrawer(); return; }
    // click on the dialog backdrop (target is the dialog itself)
    var d = drawer();
    if (d && e.target === d) { closeDrawer(); return; }

    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      var item = {
        handle: toggleBtn.dataset.handle,
        url: toggleBtn.dataset.url,
        title: toggleBtn.dataset.title,
        image: toggleBtn.dataset.image || '',
        price: toggleBtn.dataset.price || '',
        available: toggleBtn.dataset.available !== 'false'
      };
      if (item.handle) { toggle(item); reflectButtons(); }
      return;
    }
    var rm = e.target.closest('[data-wishlist-remove]');
    if (rm) { remove(rm.dataset.wishlistRemove); }
  });

  document.addEventListener('wishlist:change', function () { reflectButtons(); renderPage(); });
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { reflectButtons(); renderPage(); }
  });

  function init() { reflectButtons(); renderPage(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
